import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root',
})
export class CfeService {
  private http = inject(HttpService);

  public reciboDeLuzList = async () => await this.http.get(`/v1/cfe/recibo-de-luz`, false).then((response: any) => response.data.content.sort());
  public reciboDeLuzUpload = async (body: any) => await this.http.post(`/v1/cfe/recibo-de-luz`, body).then((response: any) => response.data);
}
